<!--
 * @description: 
 * @Author: liwg
 * @Date: 2022-09-19 16:08:43
 * @LastEditors: liwg
 * @LastEditTime: 2022-09-19 16:28:44
-->
<script lang="ts">
// import VConsole from 'vconsole'
import { Modal } from 'ant-design-vue'
import { createAppProviderContext } from '@/hooks/useAppContext'
import { detectDevice } from '@/utils/device'

export default defineComponent({
  name: 'AppProvider',
  inheritAttrs: false,
  setup(_props, { slots }) {
    const { os, browser, deviceType } = detectDevice()
    const { t } = useI18n()
    const isMobile = ref(false)
    const isPad = ref(false)
    const isTouchDevice = ref(false)
    // watch(
    //   () => isMobile.value,
    //   (val) => {
    //     if (val && location.hostname !== 'ta.csair.com') {
    //       new VConsole()
    //     }
    //   },
    //   { immediate: true }
    // )

    const isIOSBelow15 = () => {
      const ua = navigator.userAgent
      const isIOS = /iphone|ipad|ipod/i.test(ua)
      if (!isIOS) return false

      // 提取 iOS 版本号（如 "15.0"）
      const match = ua.match(/OS (\d+)_(\d+)_?(\d+)?/)
      if (!match) return false

      const majorVersion = Number.parseInt(match[1], 10)
      return majorVersion < 15 // iOS 15 以下返回 true
    }

    onMounted(() => {
      // 检测是否支持触摸事件
      isTouchDevice.value = 'ontouchstart' in window || navigator.maxTouchPoints > 0
      if (isIOSBelow15()) {
        Modal.info({
          title: t('common.systemPrompt'),
          content:
            '您的设备系统版本较低，建议升级至iOS 15或更高版本，或使用电脑访问以获得完整体验。',
          okText: '确认'
        })
      }
    })
    // const width = ref(window.innerWidth)
    useResizeObserver(document.body, (entries) => {
      const entry = entries[0]
      const { width } = entry.contentRect
      isMobile.value = width < 640
      isPad.value = width <= 1025
    })
    createAppProviderContext({ isMobile, isPad, isTouchDevice, os, browser, deviceType })
    return () => slots.default?.()
  }
})
</script>
